<template>
  <div id="contact">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>联系我们</span>
      </div>
      <ul>
        <li class="locationBack">
          <img src="src/common/img/img1.d6056a76.jpg" alt="">
        </li>
        <li>
          鄂尔多斯市安能检测检验有限公司
        </li>
        <li>
          电话：15147789878
        </li>
        <li>
          邮箱：2727864284@qq.com
        </li>
        <li>
          公司地址：内蒙古自治区鄂尔多斯市东胜区天骄北路11号金辉大厦6号楼5层03、04
        </li>
        <li>
        </li>
      </ul>
    </el-card>
  </div>
</template>

<script>
import { listInfo } from '@/api/company'
export default {
  name: 'contact',
  data () {
    return {
      tableData: [],
      total: 0, // 分页总数
      pageNum: 1, // 分页当前页码数
      pageSize: 10, // 分页数量
      search: undefined // 搜索内容
    }
  },
  methods: {
    async loadList () {
      try {
        const res = await listInfo({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          name: this.search
        })
        if (res.code === 200) {
          this.total = res.total
          this.tableData = res.rows[0]
        }
      } catch (error) {
        this.$message.error('未知错误，请重新尝试')
      }
    },
    onSearch () {
      this.pageNum = 10
      this.pageNum = 1
      this.loadList()
    }
  },
  created () {
    // this.loadList()
  }
}
</script>

<style lang='less' scoped>
  @media screen and (max-width: 767px) {
    .map {
      width: 100%;
      height: 100%;
    }
  }
  @media screen and (min-width: 768px) {
    .map {
      width: 670px;
      height: 505px;
    }
  }
  #contact {
    .box-card {
      margin: 0 auto;
      margin-top: 20px;
      width: 90%;
      text-align: left;
    }
    .clearfix {
      span {
        font-size: 20px;
      }
    }
    ul {
      padding: 0;
    }
    li {
      font-family: Arial;
      color: #6b6b6b;
      line-height: 27px;
      margin: 0;
    }
    li:first-child {
      width: 100%;
      margin-bottom: 20px;

      img{
        width: 100%;
      }
    }
    .wx {
      width: 120px;
    }
    .wxcode {
      display: flex;
      text-align: center;
    }
  }
</style>
